import { useEffect, useState } from "react";
import { CircleCheckBig } from "lucide-react";
import { Typography } from "@mui/material";
import { getEventLogs } from "./apiRoutes/eventLogs";
import * as Dialog from "@radix-ui/react-dialog";
import { QRCodeCanvas } from "qrcode.react";
import { handleLogout } from "../../mainApiRoutes/login";

const currentUrl = `${window.location.protocol}//${window.location.host}`;
const attendanceUrl = `${currentUrl}/attendance`;
console.log(attendanceUrl);

const query = new URLSearchParams(window.location.search);

const firstName = tmtSubscriberPortal.first_name;
const lastName = tmtSubscriberPortal.last_name;
const userId = tmtSubscriberPortal.user_id;

export default function SubscriberPortal() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [allEvents, setAllEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [attendedEvents, setAttendedEvents] = useState([]);
  const [selectedSections, setSelectedSections] = useState({
    allEvents: true,
    attendedEvents: false,
    upcomingEvents: false,
  });
  const [isEventSet, setIsEventSet] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    initializeEventLogs();
  }, []);

  if (!tmtSubscriberPortal.is_login) {
    window.location.href = "portal-login";
  }

  const onLogout = async () => {
    await handleLogout();
    window.location.href = "/portal-login";
  };

  const handleSectionClicked = (field) => {
    const newSelectedSections = {
      allEvents: false,
      attendedEvents: false,
      upcomingEvents: false,
    };
    newSelectedSections[field] = true;
    setSelectedSections(newSelectedSections);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleEventClicked = (event) => {
    setSelectedEvent(event);
    setIsDialogOpen(true);
  };

  const initializeEventLogs = async () => {
    const response = await getEventLogs(userId);
    const sortedEvents = response.sort((a, b) => {
      const dateA = new Date(a.start_date.replace(" ", "T"));
      const dateB = new Date(b.start_date.replace(" ", "T"));

      return dateB - dateA;
    });
    setAllEvents(sortedEvents);
    setAttendedEvents(sortedEvents.filter((val) => val.status === "1"));
    setUpcomingEvents(
      sortedEvents.filter((val) => {
        const eventDate = new Date(val.start_date.replace(" ", "T"));
        const now = new Date();

        return eventDate > now;
      })
    );

    setIsEventSet(true);
  };

  const qrValue = selectedEvent
    ? `${attendanceUrl}?key=${selectedEvent.hash}&id=${selectedEvent.event_id}&user=${selectedEvent.user_id}`
    : "";
  const attendanceCode = selectedEvent ? selectedEvent.code : "";

  return tmtSubscriberPortal.is_login ? (
    <div className="subscriber-portal-container">
      <div className="name-container">
        <div></div>
        <Typography
          variant="h1"
          component="h1"
          sx={{ fontWeight: 600, fontSize: "4rem", marginBottom: "1rem" }}
        >
          {`${lastName}, ${firstName}`}
        </Typography>
      </div>
      <button
        className="ButtonW100 wpem-theme-button"
        style={{ height: "2.5rem", width: "10rem", marginBottom: "0.5rem" }}
        onClick={() => {
          onLogout();
        }}
      >
        Log Out
      </button>
      <div className="nav-menu">
        <NavMenuItem
          name={"Upcoming Events"}
          isSelected={selectedSections.upcomingEvents}
          onClick={() => handleSectionClicked("upcomingEvents")}
        />
        <NavMenuItem
          name={"All Events"}
          isSelected={selectedSections.allEvents}
          onClick={() => handleSectionClicked("allEvents")}
        />
        <NavMenuItem
          name={"Attended Events"}
          isSelected={selectedSections.attendedEvents}
          onClick={() => handleSectionClicked("attendedEvents")}
        />
      </div>
      <div className="events-container">
        {selectedSections.allEvents &&
          (allEvents.length > 0
            ? allEvents.map((val) => (
                <EventItem
                  name={val.event_title}
                  address={val.address}
                  checkedIn={val.status === "1"}
                  startDate={val.start_date}
                  onClick={() => handleEventClicked(val)}
                />
              ))
            : isEventSet && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <p style={{ fontSize: "2rem" }}>No Events</p>
                </div>
              ))}

        {selectedSections.attendedEvents &&
          (attendedEvents.length > 0
            ? attendedEvents.map((val) => (
                <EventItem
                  name={val.event_title}
                  address={val.address}
                  checkedIn={val.status === "1"}
                  startDate={val.start_date}
                  onClick={() => handleEventClicked(val)}
                />
              ))
            : isEventSet && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <p style={{ fontSize: "2rem" }}>No Attended Events</p>
                </div>
              ))}
        {selectedSections.upcomingEvents &&
          (upcomingEvents.length > 0
            ? upcomingEvents.map((val) => (
                <EventItem
                  name={val.event_title}
                  address={val.address}
                  checkedIn={val.status === "1"}
                  startDate={val.start_date}
                  onClick={() => handleEventClicked(val)}
                />
              ))
            : isEventSet && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <p style={{ fontSize: "2rem" }}>No Upcoming Events</p>
                </div>
              ))}
      </div>
      <Dialog.Root open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="DialogOverlay" />
          <Dialog.Content className="DialogContent">
            <Dialog.Title className="DialogTitle">Attendance</Dialog.Title>
            <div className="QRCodeContainer">
              <QRCodeCanvas
                value={qrValue}
                size={250}
                level="H"
                includeMargin={true}
              />
            </div>
            <p
              style={{ fontWeight: "bolder" }}
            >{`Attendance code: ${attendanceCode}`}</p>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  ) : (
    <></>
  );
}

function NavMenuItem({ name, isSelected = false, onClick }) {
  return (
    <div
      className={`nav-menu-item ${isSelected ? "selected" : ""}`}
      onClick={onClick}
    >
      <Typography
        variant="h6"
        component="h6"
        sx={{ fontWeight: 500, fontSize: "1.25rem" }}
      >
        {name}
      </Typography>
    </div>
  );
}

function EventItem({ name, address, checkedIn = false, startDate, onClick }) {
  const date = new Date(startDate.replace(" ", "T"));

  const monthShort = date
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();
  const day = date.getDate();

  return (
    <div className="event-item" onClick={onClick}>
      <div className="event-title-container">
        <div className="event-title">
          <Typography
            variant="h1"
            component="h1"
            sx={{ fontWeight: 600, fontSize: "1.75rem" }}
          >
            {name}
          </Typography>
          {checkedIn && <CircleCheckBig size={24} color="#2d52b0" />}
        </div>
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontWeight: 500, fontSize: "1rem" }}
        >
          {address}
        </Typography>
      </div>
      <div className="date-container">
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontWeight: 600, fontSize: "1.75rem" }}
        >
          {day}
        </Typography>
        <Typography
          variant="h6"
          component="h6"
          sx={{ fontWeight: 600, fontSize: "1.25rem" }}
        >
          {monthShort}
        </Typography>
      </div>
    </div>
  );
}
